// =============================================================================
//  Copyright : 2025 semantics GmbH
//  Date      : $Date: 2025-10-15 19:14:19 +0200 (Wed, 15 Oct 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 157254 $
//  Purpose   : parts for scidesk support
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import log from 'uix/logging'
import {loadLazy as ll} from 'uix/parts'

export const AutoStruct = ll(() => import(/* webpackChunkName: 'scidesk' */ './autostruct'))
export const GraphicBoxes = ll(() => import(/* webpackChunkName: 'scidesk' */ './gboxes'))

export const ScideskStart = ({}) => {
  return 'XXXX'
}
